export default {
  placeholder: 'Caută brand...',
};
